import ExcelJS from 'exceljs';
import JSZip from 'jszip';

/**
 * 基于 JSZip generateAsync 的进度回调，提供 Excel 序列化阶段的真实进度。
 * 注意：这是文件打包阶段进度，不包含浏览器实际落盘进度（浏览器无公开 API）。
 */
export async function writeWorkbookBufferWithProgress(
  workbook: ExcelJS.Workbook,
  onProgress?: (progress: number) => void,
  range: { start: number; end: number } = { start: 80, end: 98 }
): Promise<ArrayBuffer> {
  const zipProto = (JSZip as any)?.prototype;
  const originalGenerateAsync = zipProto?.generateAsync;

  if (typeof originalGenerateAsync !== 'function') {
    return (await workbook.xlsx.writeBuffer()) as ArrayBuffer;
  }

  zipProto.generateAsync = function patchedGenerateAsync(
    options: unknown,
    onUpdate?: (metadata: { percent?: number }) => void
  ) {
    const wrappedOnUpdate = (metadata: { percent?: number }) => {
      const percent = Number(metadata?.percent ?? 0);
      if (Number.isFinite(percent)) {
        const mapped = Math.round(range.start + ((range.end - range.start) * percent) / 100);
        onProgress?.(Math.min(range.end, Math.max(range.start, mapped)));
      }
      if (typeof onUpdate === 'function') onUpdate(metadata);
    };
    return originalGenerateAsync.call(this, options, wrappedOnUpdate);
  };

  try {
    onProgress?.(range.start);
    return (await workbook.xlsx.writeBuffer()) as ArrayBuffer;
  } finally {
    zipProto.generateAsync = originalGenerateAsync;
  }
}

